module.exports = __webpack_public_path__ + "img/shape-octagon.a56342d4.jpg";